<template>
  <div v-if="type" class="modal-overlay" @click.self="handleClose">
    <!-- 心脏健康得分弹窗 - type 1 -->
    <div v-if="type === 1" class="modal-card">
      <div class="modal-header">
        <h3 class="modal-title">心脏健康得分是如何计算的？</h3>
        <img
          class="close-icon"
          src="https://sz-wonz-1305461842.cos.ap-beijing.myqcloud.com/other/3-10Popde2.png"
          alt=""
          @click="handleClose"
        />
      </div>
      <p class="modal-desc">
        您的心脏健康得分是基于多项生理指标的综合评估，包括心率变异性、静息心率、压力水平和呼吸率等维度。
      </p>
      <div class="table-container">
        <table class="info-table">
          <thead>
            <tr>
              <th>分值</th>
              <th>建议</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>90-100</td>
              <td>继续保持良好的生活习惯</td>
            </tr>
            <tr>
              <td>80-89</td>
              <td>身体状态良好，可适当优化</td>
            </tr>
            <tr>
              <td>70-79</td>
              <td>健康状况正常，注意预防</td>
            </tr>
            <tr>
              <td>60-69</td>
              <td>建议改善生活方式</td>
            </tr>
            <tr>
              <td>50-59</td>
              <td>需要关注健康状况</td>
            </tr>
            <tr>
              <td>40-49</td>
              <td>建议咨询专业医生</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- HRV健康指数弹窗 - type 2 -->
    <div v-else-if="type === 2" class="modal-card">
      <div class="modal-header">
        <h3 class="modal-title">什么是HRV健康指数？</h3>
        <img
          class="close-icon"
          src="https://sz-wonz-1305461842.cos.ap-beijing.myqcloud.com/other/3-10Popde2.png"
          alt=""
          @click="handleClose"
        />
      </div>
      <p class="modal-desc">
        HRV是心率变异性的缩写，指连续心跳间隔的微小变化。健康的心脏应该有一定的变异性，这表明自主神经系统功能良好，心脏能够灵活应对不同情况。
      </p>
      <div class="highlight-box">您的RMSSD值：{{ RMSSD || 0 }}ms ({{ getRMSSDLevel(RMSSD) }})</div>
    </div>

    <!-- 呼吸率计算弹窗 - type 3 -->
    <div v-else-if="type === 3" class="modal-card">
      <div class="modal-header">
        <h3 class="modal-title">呼吸率是如何计算的？</h3>
        <img
          class="close-icon"
          src="https://sz-wonz-1305461842.cos.ap-beijing.myqcloud.com/other/3-10Popde2.png"
          alt=""
          @click="handleClose"
        />
      </div>
      <p class="modal-desc">
        呼吸率通过心呼耦合技术从心率数据中推算。通过分析呼吸时心率的规律性微小变化（吸气时心率略快，呼气时心率略慢），计算出呼吸频率。成人正常范围为12-20次/分钟。
      </p>
    </div>

    <!-- 实时心率 - type 4 -->
    <div v-if="type === 4" class="modal-card">
      <div class="modal-header">
        <h3 class="modal-title">实时心率是如何检测的？</h3>
        <img
          class="close-icon"
          src="https://sz-wonz-1305461842.cos.ap-beijing.myqcloud.com/other/3-10Popde2.png"
          alt=""
          @click="handleClose"
        />
      </div>
      <p class="modal-desc">
        我们使用rPPG技术（远程光体积描记术）进行无接触心率检测。通过AI模型分析面部血流变化引起的微小颜色变化，精确计算出心率。无需接触或穿戴设备，30秒快速检测，准确度接近医疗级设备。
      </p>
      <div class="table-container">
        <table class="info-table">
          <thead>
            <tr>
              <th>数值</th>
              <th>说明</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>60-100</td>
              <td>正常成人静息心率范围</td>
            </tr>
            <tr>
              <td>50-60或100-110</td>
              <td>可接受范围，可能因个体差异</td>
            </tr>
            <tr>
              <td>40-50或110-120</td>
              <td>边缘范围，建议关注</td>
            </tr>
            <tr>
              <td>其他</td>
              <td>异常范围，建议咨询医生</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- 实时心率 - type 5 -->
    <div v-if="type === 5" class="modal-card">
      <div class="modal-header">
        <h3 class="modal-title">压力水平是如何计算的？</h3>
        <img
          class="close-icon"
          src="https://sz-wonz-1305461842.cos.ap-beijing.myqcloud.com/other/3-10Popde2.png"
          alt=""
          @click="handleClose"
        />
      </div>
      <p class="modal-desc">
        压力水平通过分析自主神经系统的平衡状态来评估，包括HRV频域分析、交感神经和副交感神经活性等指标。0-30为很低压力（理想状态），31-60为中等压力，61-100为高压力（需要关注）。
      </p>
      <div class="table-container">
        <table class="info-table">
          <thead>
            <tr>
              <th>数值</th>
              <th>说明</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>0-30</td>
              <td>很低压力，理想状态</td>
            </tr>
            <tr>
              <td>31-60</td>
              <td>中的压力</td>
            </tr>
            <tr>
              <td>61-100</td>
              <td>高压力（需要关注）</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HelpModal",
  props: {
    RMSSD: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      type: 0,
      originalBodyOverflow: "", // 保存原始 overflow 值
    };
  },
  mounted() {
    // 如果组件创建时 也需要禁止滚动（但一般初始为 false）
    if (this.type) {
      this.disableBodyScroll();
    }
  },
  beforeDestroy() {
    // 组件销毁前确保恢复滚动（防止组件被强行移除时滚动仍被禁用）
    this.enableBodyScroll();
  },
  watch: {
    // 监听弹窗显示状态，控制body滚动
    type(val) {
      if (val) {
        // 弹窗显示：禁止背景滚动
        this.disableBodyScroll();
      } else {
        // 弹窗隐藏：恢复背景滚动
        this.enableBodyScroll();
      }
    },
  },
  mounted() {
    // 组件挂载时，禁止body滚动
    if (this.type) {
      this.disableBodyScroll();
    }
  },
  beforeDestroy() {
    // 组件销毁时，恢复body滚动
    this.enableBodyScroll();
  },
  methods: {
    // 根据 RMSSD 值返回等级描述
    getRMSSDLevel(rmssd) {
      // 先做类型校验，确保传入是数字
      const value = Number(rmssd);
      if (isNaN(value)) {
        return "未知";
      }

      if (value > 50) {
        return "优秀";
      } else if (value > 30) {
        return "良好";
      } else if (value > 20) {
        return "一般";
      } else if (value > 15) {
        return "偏低";
      } else {
        // ≤15
        return "较差";
      }
    },
    open(t) {
      this.type = t || 0;
    },
    /**
     * 关闭弹窗
     * 触发 close 事件通知父组件
     */
    handleClose() {
      this.type = 0;
    },
    disableBodyScroll() {
      // 保存当前 body 的 overflow 样式（可能为空或已有值）
      this.originalBodyOverflow = document.body.style.overflow;
      document.body.style.overflow = "hidden";
    },
    enableBodyScroll() {
      // 恢复原来的 overflow 样式
      document.body.style.overflow = this.originalBodyOverflow;
      // 清除保存的值（可选）
      this.originalBodyOverflow = "";
      this.type = 0;
    },
  },
};
</script>

<style lang="scss" scoped>
@media all and (min-width: 768px) {
  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.7);
    backdrop-filter: blur(4px);
    -webkit-backdrop-filter: blur(4px);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 2rem;
    box-sizing: border-box;
    z-index: 9999;
    overflow-y: auto;

    .modal-card {
      width: 100%;
      max-width: 68.75rem;
      background: #ffffff;
      border-radius: 1.25rem;
      padding: 2rem;
      box-sizing: border-box;
      animation: modalSlideIn 0.3s ease-out;
      max-height: 90vh;
      overflow-y: auto;

      .modal-header {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        margin-bottom: 1rem;

        .modal-title {
          font-size: 1.875rem;
          font-weight: 600;
          color: #0074fc;
          margin: 0;
          flex: 1;
          padding-right: 1rem;
        }

        .close-icon {
          width: 1.875rem;
          height: 1.875rem;
          cursor: pointer;
          flex-shrink: 0;
          transition: opacity 0.2s;

          &:hover {
            opacity: 0.7;
          }
        }
      }

      .modal-desc {
        font-size: 1.25rem;
        color: #333333;
        font-weight: 400;
        color: #101424;
        line-height: 2rem;
        margin-bottom: 1.5rem;
      }

      .table-container {
        background: #fff;
        overflow: hidden;

        .info-table {
          font-size: 1.2rem;
          width: 100%;
          border-spacing: 0;
          border-radius: 1.25rem;
          overflow: hidden;
          border: 1px solid rgba(0, 116, 252, 0.5);

          thead {
            margin: 0;
            padding: 0;
            tr {
              background: #e3f0ff;

              th {
                padding: 1rem 1.5rem;
                padding-left: 5rem;
                text-align: left;
                font-weight: 600;
                color: #0074fc;
                border-bottom: 1px solid #f5f6fe;
              }

              th:first-child {
                width: 25%;
                border-right: 1px solid #f5f6fe;
              }
            }
          }

          tbody {
            margin: 0;
            padding: 0;
            tr {
              border-bottom: 1px solid #f5f6fe;

              &:last-child {
                border-bottom: none;
              }

              td {
                padding: 1rem 1.5rem;
                padding-left: 5rem;
                border-bottom: 1px solid #f5f6fe;
                border-right: 1px solid #f5f6fe;
                font-size: 1.2rem;
                color: #333333;
                line-height: 1.6;
              }

              td:first-child {
                color: #666666;
                font-weight: 500;
              }
            }
          }
        }
      }

      .highlight-box {
        background: #e8f4ff;
        border-radius: 0.75rem;
        padding: 1.5rem;
        text-align: center;
        font-size: 1.4rem;
        color: #0074fc;
        font-weight: 500;
      }
    }
  }
}
@media (max-width: 767px) {
  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.7);
    backdrop-filter: blur(4px);
    -webkit-backdrop-filter: blur(4px);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 2rem;
    box-sizing: border-box;
    z-index: 9999;
    overflow-y: auto;

    .modal-card {
      width: 38rem;
      background: #ffffff;
      border-radius: 1.25rem;
      padding: 2rem;
      box-sizing: border-box;
      animation: modalSlideIn 0.3s ease-out;
      max-height: 90vh;
      overflow-y: auto;

      .modal-header {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        margin-bottom: 1rem;

        .modal-title {
          font-size: 1.875rem;
          font-weight: 600;
          color: #0074fc;
          margin: 0;
          flex: 1;
          padding-right: 1rem;
        }

        .close-icon {
          width: 2rem;
          height: 2rem;
          margin-top: 0.5rem;
          cursor: pointer;
          flex-shrink: 0;
          transition: opacity 0.2s;

          &:hover {
            opacity: 0.7;
          }
        }
      }

      .modal-desc {
        font-size: 1.4rem;
        color: #333333;
        font-weight: 400;
        color: #101424;
        line-height: 2rem;
        margin-bottom: 1.5rem;
      }

      .table-container {
        background: #fff;
        overflow: hidden;

        .info-table {
          font-size: 1.4rem;
          width: 100%;
          border-spacing: 0;
          border-radius: 1.5rem;
          overflow: hidden;
          border: 1px solid rgba(0, 116, 252, 0.5);

          thead {
            margin: 0;
            padding: 0;
            tr {
              background: #e3f0ff;

              th {
                padding: 1rem;
                // padding-left: 5rem;
                text-align: center;
                font-weight: 600;
                color: #0074fc;
                border-bottom: 1px solid #f5f6fe;
              }

              th:first-child {
                text-align: center;
                width: 30%;
                border-right: 1px solid #f5f6fe;
              }
            }
          }

          tbody {
            margin: 0;
            padding: 0;
            tr {
              text-align: center;
              border-bottom: 1px solid #f5f6fe;

              &:last-child {
                text-align: center;
                border-bottom: none;
              }

              td {
                padding: 1rem 1.5rem;
                text-align: center;
                border-bottom: 1px solid #f5f6fe;
                border-right: 1px solid #f5f6fe;
                font-size: 1.4rem;
                color: #333333;
                line-height: 1.6;
              }

              td:first-child {
                text-align: center;
                color: #666666;
                font-weight: 500;
              }
            }
          }
        }
      }

      .highlight-box {
        background: #e8f4ff;
        border-radius: 0.75rem;
        padding: 1.5rem;
        text-align: center;
        font-size: 1.4rem;
        color: #0074fc;
        font-weight: 500;
      }
    }
  }
}

@keyframes modalSlideIn {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>